// extracted by mini-css-extract-plugin
module.exports = {"oefening":"Oefening-module--oefening--3d6tK","number":"Oefening-module--number--RjmF_"};